import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required, minLength } from '@vuelidate/validators';
import CreditCardInfo from '@/components/creditcards/Info';
import CreditCardLogo from '@/components/creditcards/Logo';
import CreditCardAddress from '@/components/creditcards/Address';
export default {
  name: 'Verify',
  components: {
    CreditCardInfo,
    CreditCardLogo,
    CreditCardAddress
  },
  props: {
    card: Object,
    allowReset: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      cvc: null,
      error: null
    };
  },
  methods: {
    validateCardCVC() {
      this.$v.cvc.$touch();
      this.error = null;
      if (!this.$cardFormat.validateCardCVC(this.cvc)) {
        this.error = 'Invalid CVC';
      }
    }
  },
  watch: {
    '$v.$invalid'() {
      this.$emit('isValid', !this.$v.$invalid);
    },
    cvc() {
      this.$emit('update', this.cvc);
    }
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    cvc: {
      required,
      minLength: minLength(3)
    }
  }
};